<template>
  <div>
    <div class="medium-margin-v-s">
      <div class="ads" v-if="!!ads.ID" @click="showAds">
        <div class="img">
          <img :src="ads.tooltipImage" />
        </div>
        <div class="text">
          <span class="title">{{ ads.tooltipTitle }}</span>
          <span class="desc">{{ ads.tooltipDescription }}</span>
        </div>
      </div>
    </div>

    <div class="card medium-margin-v-s" id="rideDetails1">
      <h3 :class="{'margin-t-z margin-b-s':true, 'has-error':this.stepsError.one}">{{ $t('serviceSelect.rideDetails') }}</h3>
      <ride-details leg="leg1" ref="rideDetails1" @nextHighlight="highlightCheck" @noErrors="stepsError.one = false"></ride-details>
    </div>

    <div :class="{'card margin-t-s medium-margin-v-s service-leg1':true, 'highlight':highlight.leg1 === 'service'}"
      id="service1">
      <change-service :leg="'leg1'"></change-service>
      <h3 :class="{'margin-t-z margin-b-s':true, 'has-error':this.stepsError.two}">{{ $t('serviceSelect.selectService') }}</h3>
      <span class='error-msg' v-if="!!serviceLeg1Error">{{ serviceLeg1Error }}</span>
      <services leg="leg1" ref="service1" v-if="!mtech.enabled"></services>
      <mtech-services leg="leg1" ref="mtechService1" v-else></mtech-services>
    </div>

    <optin-shared leg="leg1"></optin-shared>

    <transition name="slide-down">
      <div class="card margin-t-s medium-margin-v-s" v-if="showLAXInstructionLeg1">
        <div  class="row lax-instruction">
          <h3 class="margin-t-z margin-b-xs">{{ pickupInstruction.title }}</h3>
          <div :class="['column end', noPickupInstructionImgLeg1 ? ' medium-12': ' medium-8']">
            <div v-if="leg1LicenseType === 'tnc'" v-html="pickupInstruction.tnc.text"></div>
            <div v-if="leg1LicenseType === 'tcp'" v-html="pickupInstruction.tcp.text"></div>
          </div>
          <div class="column medium-4" v-if="!noPickupInstructionImgLeg1">
            <img v-if="leg1LicenseType === 'tnc'" :src="pickupInstruction.tnc.img" class="thumbnail" @click="showLaxIntructionImg('tnc')" />
            <img v-if="leg1LicenseType === 'tcp'" :src="pickupInstruction.tcp.img" class="thumbnail" @click="showLaxIntructionImg('tcp')" />
            <span class="large-view">{{ $t('serviceSelect.clickImage') }}</span>
          </div>
        </div>
      </div>
    </transition>

    <transition name="slide-down">
      <div class="card margin-t-s medium-margin-v-s roundtrip-box" id="rideDetails2"
        v-show="isRoundtrip">
        <a class="cancel-roundtrip" @click="setRoundtrip(0)">{{ $t('serviceSelect.dontWantRT') }}</a>
        <!-- <change-service :leg="'leg2'"></change-service> -->
        <h3 :class="{'margin-t-z margin-b-s':true, 'has-error':this.stepsError.three}">{{ $t('serviceSelect.rtDetails') }}</h3>
        <ride-details leg="leg2" ref="rideDetails2" @nextHighlight="highlightCheck" @noErrors="stepsError.three = false"></ride-details>
      </div>
    </transition>

    <transition name="slide-down">
      <span class='error-msg service-na' v-if="!serviceLoading && isRoundtrip && leg2ServiceNotAvailable">
        <b>{{noSameServiceLabel}}</b> 
        {{ $t('serviceSelect.isNotAvailable') }}
      </span>
    </transition>

    <transition name="slide-down">
      <span class='error-msg service-na' v-if="!!serviceLeg2Error && isRoundtrip && !leg2SharedUnavailable">
        {{ serviceLeg2Error }}
      </span>
    </transition>

    <div v-show="!serviceLoading && isRoundtrip && !leg2ServiceNotAvailable">
      <transition name="slide-down">
        <div :class="['card margin-t-s medium-margin-v-s', {'highlight':highlight.leg2 === 'service'}]" id="service2"
          v-show="roundtrip && leg2SharedUnavailable">
          <!-- <a class="change-service" v-show="hasService.leg2"
            @click="_changeService('leg2')">{{ $t('serviceSelect.changeSelect') }}</a> -->
          <change-service :leg="'leg2'"></change-service>
          <h3 :class="['margin-t-z margin-b-s', {'has-error':this.stepsError.four}]">{{ $t('serviceSelect.chooseService') }}</h3>
          <span class='error-msg' v-if="!!serviceLeg2Error">{{ serviceLeg2Error }}</span>
          <services leg="leg2" ref="service2" @rerender="initRerender" v-if="rerender.service2"></services>
        </div>
      </transition>
    </div>

    <optin-shared leg="leg2"></optin-shared>

    <transition name="slide-down">
      <div class="card margin-t-s medium-margin-v-s" v-if="showLAXInstructionLeg2">
        <div  class="row lax-instruction">
          <h3 class="margin-t-z margin-b-xs">{{ pickupInstruction.title }}</h3>
          <div :class="['column end', noPickupInstructionImgLeg2 ? ' medium-12': ' medium-8']">
            <div v-if="leg2LicenseType === 'tnc'" v-html="pickupInstruction.tnc.text"></div>
            <div v-if="leg2LicenseType === 'tcp'" v-html="pickupInstruction.tcp.text"></div>
          </div>
          <div class="column medium-4" v-if="!noPickupInstructionImgLeg2">
            <img v-if="leg2LicenseType === 'tnc'" :src="pickupInstruction.tnc.img" class="thumbnail" @click="showLaxIntructionImg('tnc')" />
            <img v-if="leg2LicenseType === 'tcp'" :src="pickupInstruction.tcp.img" class="thumbnail" @click="showLaxIntructionImg('tcp')" />
            <span class="large-view">{{ $t('serviceSelect.clickImage') }}</span>
          </div>
        </div>
      </div>
    </transition>

    <div class="service-controls margin-t-m medium-margin-v-s">
      <span class="op-btn btn-lg return-trip-btn small btn-block"
        @click="setRoundtrip(1)" v-show="showRoundtripOption && !charter.enabled">
        <div class="float-effect">
          <div class="bubble">{{ $t('serviceSelect.returnLater') }}</div>
        </div>
        <i class="fas fa-exchange-alt fa-fw margin-r-xs"></i>
        <span>{{ $t('serviceSelect.bookRt') }}</span>
      </span>

      <a href="#/search" class="op-btn btn-lg margin-r-xs back-btn d-flex justify-center align-center" @click="back($event)">
        <icon name="chevron-left" class="margin-r-s"></icon>
        <span>{{ $t('common.back') }}</span>
      </a>

      <span class="op-btn btn-lg return-trip-btn" @click="setRoundtrip(1)" v-show="showRoundtripOption && !charter.enabled">
        <div class="float-effect">
          <div class="bubble">{{ $t('serviceSelect.returnLater') }}</div>
        </div>
        <i class="fas fa-exchange-alt fa-fw margin-r-xs"></i>
        <span>{{ $t('serviceSelect.bookRt') }}</span>
      </span>

      <a href="#/customer" :class="['op-btn btn-lg btn-success margin-l-xs continue-btn', {disabled:serviceLoading}]" @click="submit($event)">
        <span>{{ $t('common.continue') }}</span>
        <icon name="chevron-right" class="margin-l-s"></icon>
      </a>

      <div class="clearfix"></div>
    </div>

    <div class="roundtrip-controls" v-if="showRoundtripOption">
      <transition name="slide-up">
        <div class="roundtrip-discount margin-b-m" v-if="showRoundtripPromoPrice">
          <img src="../../assets/img/roundtrip-banner.png" />
          <span :class="{seven:roundtripPromoPrice.length === 7, nine:roundtripPromoPrice.length === 9, 'ten-above':roundtripPromoPrice.length > 9}">{{ roundtripPromoPrice }}</span>
        </div>
      </transition>
    </div>

    <date-time-picker :leg="leg"></date-time-picker>
    <flight-modal :leg="leg"></flight-modal>

    <div :class="{ 'op--modal-container':true, hide: !ads.show }"
      v-if="!!ads.ID" @click="closeAds">
      <div class="op--modal">
        <div class="op--modal-content">
          <div class="ads-modal" @click.stop>
            <div class="ads-title">
              <i class="fas fa-times fa-lg" @click="closeAds"></i>
              {{ ads.mainTitle }}
            </div>
            <div class="ads-img"><img :src="ads.mainImage" /></div>
            <div class="ads-heading">{{ ads.mainHeader }}</div>
            <div class="ads-desc" v-html="ads.mainBody"></div>
            <div class="ads-cta" v-if="!!ads.ctaText">
              <a :href="ads.ctaLink" class="op-btn btn-lg btn-success margin-b-m"
                target="_blank" v-if="isUrl(ads.ctaLink)">{{ ads.ctaText }}</a>
              <a @click="selectService(ads.ctaLink)" v-else
                class="op-btn btn-lg btn-success margin-b-m">{{ ads.ctaText }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SUGGESTED TIME MODAL -->
    <div :class="{'op--modal-container':true, hide: true}"
      @click="closeSuggestedTime">
      <div class="op--modal">
        <div class="op--modal-content">
          <div class="suggested-time-box" @click.stop>
            <transition name="slide-down">
              <div class="box" v-if="showSuggestedTimeLeg1">
                <div class="title">
                  {{ $t('serviceSelect.suggestedPickupTime') }}
                  <span v-show="isRoundtrip">{{ $t('serviceSelect.firstTrip') }}</span>
                </div>
                <p v-if="airportPickup.leg1">{{ $t('serviceSelect.toMakeSurePickup') }}</p>
                <p v-else>{{ $t('serviceSelect.toMakeSureFlight') }}</p>
                <span class="time">{{ suggestedTime('leg1') }}</span>
                <span class="op-btn btn-lg btn-success btn-block"
                  @click="applySuggestedTime('leg1')">{{ $t('serviceSelect.yesSuggested') }}</span>
                  <a class="keep" v-if="showSuggestedTimeLeg1 && showSuggestedTimeLeg2" @click="showNextSuggestion">{{ $t('serviceSelect.noKeep') }}</a>
                  <a class="keep" v-else @click="closeSuggestedTime">{{ $t('serviceSelect.noKeep') }}</a>
              </div>
            </transition>
            <transition name="slide-down">
              <div class="box" v-if="!showSuggestedTimeLeg1 && showSuggestedTimeLeg2">
                <div class="title">{{ $t('serviceSelect.suggestedPickupTimeReturn') }}</div>
                <p v-if="airportPickup.leg2">{{ $t('serviceSelect.toMakeSureFlight') }}</p>
                <p v-else>{{ $t('serviceSelect.manualPickup') }}</p>
                <span class="time">{{ suggestedTime('leg2') }}</span>
                <span class="op-btn btn-lg btn-success btn-block"
                  @click="applySuggestedTime('leg2')">{{ $t('serviceSelect.yesSuggested') }}</span>

                <a class="keep" @click="closeSuggestedTime">{{ $t('serviceSelect.noKeep') }}</a>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <!-- SUGGESTED TIME - ERROR MODAL -->
    <div :class="{'op--modal-container':true, hide: !showSuggestedTimeError}"
      @click="showSuggestedTimeError = false">
      <div class="op--modal">
        <div class="op--modal-content">
          <div class="suggested-time-error-box" @click.stop>
            <i class="far fa-frown fa-5x"></i>
            <span>{{ $t('serviceSelect.wereSorry') }}</span>
            <div class="op-btn btn-danger btn-block" @click="showSuggestedTimeError = false">{{ $t('common.close') }}</div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'op--modal-container':true, hide: !LAXInstructionImg.show}"
      @click="LAXInstructionImg.show = false">
      <div class="op--modal">
        <div class="op--modal-content">
          <div class="LAX-instruction-img" @click.stop>
            <img :src="pickupInstruction.tnc.img" v-if="LAXInstructionImg.type === 'tnc'" />
            <img :src="pickupInstruction.tcp.img" v-else />
          </div>
        </div>
      </div>
    </div>

    <pickup-instruction @next="proceedToCustomer"></pickup-instruction>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import RideDetails from './RideDetails'
import Services from './Services'
import MtechServices from './MTechServices'
import ApiQuote from '@/modules/api/quote'
import DateTimePicker from './DateTimePicker'
import FlightModal from './FlightModal'
import ChangeService from './ChangeService'
import OptinShared from './OptinShared'
import PickupInstruction from './PickupInstruction'
import ApiAds from '@/modules/api/ads'
import featureToggle from '@/modules/api/featureToggle'
import { isValidNumber } from 'libphonenumber-js'
import ApiPickupType from '@/modules/api/pickup-type'
import xcurrency from '@/modules/api/currency'

// import AlephBet from 'alephbet'

export default {
  name: 'service-selection',
  components: {
    RideDetails,
    Services,
    MtechServices,
    DateTimePicker,
    FlightModal,
    ChangeService,
    OptinShared,
    PickupInstruction
  },
  data () {
    return {
      roundtrip: false,
      stepsError: {
        one: false,
        two: false,
        three: false,
        four: false
      },
      serviceLeg1Error: '',
      serviceLeg2Error: '',
      scrollDelay: '',
      transitionClassDelay: '',
      lastSelectedService: {
        leg1: '',
        leg2: ''
      },
      showSuggestedTimeError: false,
      offsets: {},
      LAXInstructionImg: {
        show: false,
        type: '',
        tnc: '',
        tcp: ''
      },
      rerender: {
        service1: true,
        service2: true
      }
    }
  },
  computed: {
    rsvpData () { return this.$store.state.reservation },
    isRoundtrip () {
      this.roundtrip = this.rsvpData.isRoundtrip
      return this.roundtrip
    },
    showRoundtripOption () {
      let leg1 = this.rsvpData.leg1

      return !this.mtech.enabled && !this.isRoundtrip && !leg1.isAsap && !!leg1.selectedService &&
        !!leg1.pickupDate && leg1.luggage !== '' &&
        ((!leg1.isAirportPickup && !leg1.isAirportDropoff) ||
        ((leg1.isAirportPickup || leg1.isAirportDropoff) && !!leg1.airline && !!leg1.flightNo))
    },
    showRoundtripDiscountOption () {
      let leg1 = this.rsvpData.leg1
      return !this.isRoundtrip && !leg1.isAsap && !!leg1.selectedService
    },
    airlineLoading () { return this.rsvpData.airlineLoading },
    sameService () {
      let rsvp = this.rsvpData
      return rsvp.leg1.selectedService !== '' &&
        rsvp.leg1.selectedService === rsvp.leg2.selectedService
    },
    leg () { return this.rsvpData.activeLeg },
    _isAsap () { return this.rsvpData.leg1.isAsap },
    showRoundtripPromoPrice () {
      if (this.charter.enabled || this.mtech.enabled || this.lyft.enabled) { return false }
      let rsvp = this.rsvpData.leg1
      let serviceData = rsvp.services[rsvp.selectedService]
      let a = !!rsvp.selectedService && rsvp.passenger <= serviceData.maxPassengers &&
        serviceData && serviceData.roundtrip[rsvp.passenger - 1].discount > 0
      return a
    },
    roundtripPromoPrice () {
      if (this.charter.enabled || this.mtech.enabled) { return 0 }
      let rsvp = this.rsvpData.leg1
      let serviceData = rsvp.services[rsvp.selectedService]
      let paxIndex = rsvp.passenger - 1
      if (serviceData && paxIndex < serviceData.maxPassengers) {
        let discount = (parseFloat(serviceData.roundtrip[paxIndex].discount) * 2).toFixed(2)
        if (this.currency.code !== 'USD') {
          discount = parseFloat(discount) * this.currency.value
          discount = discount.toFixed(2)
        }
        return xcurrency.format({
          code: this.currency.code,
          val: discount
        })
      }
    },
    hasService () {
      return {
        leg1: this.rsvpData.leg1.selectedService !== '',
        leg2: this.rsvpData.leg2.selectedService !== ''
      }
    },
    _serviceLeg1 () { return this.rsvpData.leg1.selectedService },
    _serviceLeg2 () { return this.rsvpData.leg2.selectedService },
    highlight () {
      return {
        leg1: this.rsvpData.highlight.leg1,
        leg2: this.rsvpData.highlight.leg2
      }
    },
    ads () {
      let ads = {}
      if (this.$store.state.ads.list.length) {
        ads = this.$store.state.ads.list[0]
      }
      ads.show = this.$store.state.ads.show
      return ads
    },
    _brandId () { return this.$store.state.brandId },
    brandCode () { return this.$store.state.brandCode },
    leg2SharedUnavailable () {
      let rsvp = this.rsvpData

      if (this.lyft.enabled) return true

      if (this.roundtrip && (rsvp.leg2.selectedService === '' ||
        (rsvp.leg2.selectedService !== '' && rsvp.sharedNotAvaialble.leg2 &&
        rsvp.leg1.selectedService !== rsvp.leg2.selectedService))
      ) {
        if (this.transitionClassDelay) { clearTimeout(this.transitionClassDelay) }
        this.transitionClassDelay = setTimeout(function () {
          document.getElementById('service2').className = document.getElementById('service2').className.replace('slide-down-leave-to', '')
        }, 100)
      }
      return rsvp.leg2.selectedService === '' ||
        (rsvp.leg2.selectedService && rsvp.leg1.selectedService !== rsvp.leg2.selectedService)
    },
    _airlineLeg1 () { return this.rsvpData.leg1.airline },
    _airlineLeg2 () { return this.rsvpData.leg2.airline },
    _flightNoLeg1 () { return this.rsvpData.leg1.flightNo },
    _flightNoLeg2 () { return this.rsvpData.leg2.flightNo },
    showSuggestedTime () { return this.rsvpData.suggestedTime.show },
    showSuggestedTimeLeg1 () { return this.rsvpData.suggestedTime.leg1.show },
    showSuggestedTimeLeg2 () { return this.rsvpData.suggestedTime.leg2.show },
    _suggestedTimeLeg1 () { return this.rsvpData.suggestedTime.leg1.time },
    _suggestedTimeLeg2 () { return this.rsvpData.suggestedTime.leg2.time },
    airportPickup () {
      let rsvp = this.rsvpData
      return {
        leg1: rsvp.leg1.isAirportPickup,
        leg2: rsvp.leg2.isAirportPickup
      }
    },
    _pickupTimeOffsets () { return this.$settings.get('PickupTimeOffsets') },
    showLAXInstructionLeg1 () {
      let leg1 = this.rsvpData.leg1
      let hasData = false
      if (this.leg1LicenseType === 'tnc') {
        hasData = this.pickupInstruction.title && (this.pickupInstruction.tnc.text || this.pickupInstruction.tnc.img)
      }
      if (this.leg1LicenseType === 'tcp') {
        hasData = this.pickupInstruction.title && (this.pickupInstruction.tcp.text || this.pickupInstruction.tcp.img)
      }
      let geofenceId = this.charter.enabled ? this.charter.airportGeoId : leg1.pickup.geofenceId
      if (this.charter.enabled) {
        return leg1.isAirportPickup &&
          (geofenceId === CONFIG.laxGeofenceId || CONFIG.showArrivalInstruction.indexOf(geofenceId) > -1) &&
          leg1.selectedService && ['tnc', 'tcp'].indexOf(leg1.services[leg1.selectedService].licenseType) > -1
      }
      return !this.mtech.enabled && leg1.isAirportPickup &&
        (geofenceId === CONFIG.laxGeofenceId || CONFIG.showArrivalInstruction.indexOf(geofenceId) > -1) &&
        leg1.selectedService && ['tnc', 'tcp'].indexOf(leg1.services[leg1.selectedService].licenseType) > -1 &&
        hasData
    },
    leg1LicenseType () {
      let leg1 = this.rsvpData.leg1
      if (this.mtech.enabled || !leg1.selectedService || !leg1.services[leg1.selectedService]) { return 'A' }
      return leg1.services[leg1.selectedService] ? leg1.services[leg1.selectedService].licenseType : ''
    },
    showLAXInstructionLeg2 () {
      let leg2 = this.rsvpData.leg2
      let hasData = false
      if (this.leg2LicenseType === 'tnc') {
        hasData = this.pickupInstruction.title && (this.pickupInstruction.tnc.text || this.pickupInstruction.tnc.img)
      }
      if (this.leg2LicenseType === 'tcp') {
        hasData = this.pickupInstruction.title && (this.pickupInstruction.tcp.text || this.pickupInstruction.tcp.img)
      }
      return !this.mtech.enabled && this.rsvpData.isRoundtrip && leg2.isAirportPickup &&
        (leg2.pickup.geofenceId === CONFIG.laxGeofenceId || CONFIG.showArrivalInstruction.indexOf(leg2.pickup.geofenceId) > -1) &&
        leg2.services[leg2.selectedService] &&
        ['tnc', 'tcp'].indexOf(leg2.services[leg2.selectedService].licenseType) > -1 && hasData
    },
    leg2LicenseType () {
      let leg2 = this.rsvpData.leg2
      if (this.mtech.enabled || !leg2.selectedService || !leg2.services[leg2.selectedService]) { return '' }
      return leg2.services[leg2.selectedService].licenseType
    },
    pickupInstruction () { return this.$store.state.instructions },
    noPickupInstructionImgLeg1 () {
      return (this.leg1LicenseType === 'tnc' && !this.pickupInstruction.tnc.img) ||
        (this.leg1LicenseType === 'tcp' && !this.pickupInstruction.tcp.img)
    },
    noPickupInstructionImgLeg2 () {
      return (this.leg2LicenseType === 'tnc' && !this.pickupInstruction.tnc.img) ||
        (this.leg2LicenseType === 'tcp' && !this.pickupInstruction.tcp.img)
    },
    extraStop () { return this.rsvpData.extraStop },
    serviceLoading () { return this.rsvpData.serviceLoading },
    charter () { return this.rsvpData.charter },
    leg2ServiceNotAvailable () {
      if (!this._serviceLeg1 || !this.isRoundtrip || !Object.keys(this.rsvpData.leg2.services).length) return false
      if (this.isRoundtrip && this.lyft.enabled) return false
      if (!this.rsvpData.leg2.services[this._serviceLeg1]) return true
    },
    noSameServiceLabel () {
      if (this.mtech.enabled) {
        return !this._serviceLeg1 ? '' : this.rsvpData.mtech.leg1.services[this._serviceLeg1].name
      }
      return !this._serviceLeg1 ? '' : this.rsvpData.leg1.services[this._serviceLeg1].brandedName
    },
    _applySuggestedLeg2 () { return this.rsvpData.applySuggestedLeg2 },
    mtech () { return this.rsvpData.mtech },
    currency () { return this.$store.state.other.currency },
    lyft () { return this.rsvpData.lyft }
  },
  methods: {
    buildServiceData (data) {
      let oneway = []
      let roundtrip = []
      for (let i = 0; i < data.maxPassengers; i++) {
        data.oneway[i].price = parseFloat(data.oneway[i].price)
        data.oneway[i].original = parseFloat(data.oneway[i].original)
        data.roundtrip[i].price = parseFloat(data.roundtrip[i].price)
        data.roundtrip[i].original = parseFloat(data.roundtrip[i].original)

        oneway.push(data.oneway[i])
        roundtrip.push(data.roundtrip[i])
      }

      return {
        id: data.id,
        code: data.code,
        brandedName: data.brandedName,
        maxLuggage: data.maxLuggage,
        maxPassengers: data.maxPassengers,
        curbside: data.curbside,
        meetAndGreet: data.meetAndGreet,
        pickupFee: data.pickupFee,
        prices: oneway,
        roundtrip: roundtrip,
        status: data.status,
        airportFee: data.airportFee
      }
    },
    setRoundtrip (x) {
      let self = this

      self.$store.commit('reservation/setIsRoundtrip', x === 1)
      if (x === 0) return

      let leg1 = this.rsvpData.leg1
      self.$store.commit('reservation/setPickup', { leg: 'leg2', value: leg1.dropoff })
      self.$store.commit('reservation/setDropoff', { leg: 'leg2', value: leg1.pickup })

      self.$store.commit('reservation/setPickupDate', { leg: 'leg2', value: moment(leg1.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false)).add(1, 'days').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false)) })

      let leg2 = self.rsvpData.leg2
      if (!leg2.passenger) {
        self.$store.commit('reservation/setPassenger', { leg: 'leg2', value: leg1.passenger })
        self.$store.commit('reservation/setLuggage', { leg: 'leg2', value: leg1.luggage })
      }
      self.$store.commit('reservation/setSelectedService', { leg: 'leg2', value: leg1.selectedService })
      if (/*CONFIG.Env == 'production' &&*/ window.gtag) { // eslint-disable-line
        let service = leg1.services[leg2.selectedService]
        if (leg2.selectedService) gtag('event', `Service_LEG2_${service.brandedName}`) // eslint-disable-line
      }
      self.updatePickupType()

      let pickupDate = leg2.pickupDate || leg2.flightDate
      pickupDate = pickupDate || moment().format('MM/DD/YYYY')
      pickupDate = moment(pickupDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let quoteData = {
        date: pickupDate,
        leg: 'leg2',
        brandId: self.$store.state.brandId,
        pickup: { lat: leg2.pickup.lat, lng: leg2.pickup.lng },
        dropoff: { lat: leg2.dropoff.lat, lng: leg2.dropoff.lng },
        asap: this._isAsap
      }

      quoteData = {
        brandId: self.$store.state.brandId,
        leg: 'leg2',
        pickupDate: pickupDate,
        pickup: {
          lat: leg2.pickup.lat,
          lng: leg2.pickup.lng
        },
        dropoff: {
          lat: leg2.dropoff.lat,
          lng: leg2.dropoff.lng
        },
        order: 'priority'
      }
      quoteData.pickup = leg2.pickup
      quoteData.dropoff = leg2.dropoff
      self.extraStop.leg2.forEach((stop, index) => {
        if (!quoteData.extraStops) {
          quoteData.extraStops = []
        }
        quoteData.extraStops.push({
          lat: stop.location.lat,
          lng: stop.location.lng
        })
      })
      ApiQuote.getQuote2(self, quoteData, (res) => {
        self.$root.$emit('updateRsvp', {
          leg1: self.buildLegData('leg1'),
          leg2: self.buildLegData('leg2')
        })
        self.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
        if (!res.error) {
          if (res.geofences.pickup && res.geofences.pickup.type === 'airport') {
            self.getAirlineList('leg2')
          }
          self.updatePickupType()
        }
      })
    },
    getAirlineList (leg) {
      let self = this

      let pickup = self.rsvpData[leg].pickup
      if (typeof pickup.geofenceType === 'undefined' || pickup.geofenceType !== 'airport') { return }

      if (self.airlineLoading || self.rsvpData.airlineGID === pickup.geofenceId) { return }
      self.$store.commit('reservation/setAirlineLoading', true)

      self.$sdk.get(self, '/geofences/' + pickup.geofenceId + '/airlines', {}, res => {
        self.$store.commit('reservation/setAirlineLoading', false)
        if (!res.error) {
          let airlines = []
          res.list.forEach(function (data) {
            airlines.push({
              code: data.code,
              name: data.name,
              label: '(' + data.code + ') ' + data.name
            })
          })
          self.$store.commit('reservation/setAirlineList', {
            id: pickup.geofenceId,
            list: airlines
          })
        }
      }, '/1.1')
    },
    back (event) {
      if (event) event.preventDefault()
      // this.$root.$router.push('search')

      // if (window.opoliCNS) {
      //   let leg1 = this.rsvpData.leg1
      //   let leg2 = this.rsvpData.leg2
      //   let segment = {
      //     key: 'ServicePage',
      //     'ServiceType': this._serviceLeg1 ? leg1.services[this._serviceLeg1].brandedName : '',
      //     'Single Ride Price': this._serviceLeg1 ? leg1.services[this._serviceLeg1].prices[leg1.passenger + 1].price : '',
      //     'Round Trip Price': this.rsvpData.isRoundtrip && this._serviceLeg2 ? leg2.services[this._serviceLeg2].prices[leg2.passenger + 1].price : '',
      //     'Date Scheduled': leg1.pickupDate,
      //     'Airline Info': leg1.airline,
      //     'Flight No': leg1.flightNo,
      //     'Domestic Flight': this.rsvpData.suggestedTime.leg1.isDomestic ? 'Yes' : 'No',
      //     'Pick me up ASAP': leg1.isAsap ? 'Yes' : 'No',
      //     'Passengers': leg1.passenger,
      //     'Check-in Luggage': leg1.luggage,
      //     'ServicePage_Abandonment': 'Yes',
      //     'ServicePage_Continue': 'No',
      //     'Book A Return Trip': this.rsvpData.isRoundtrip ? 'Yes' : 'No',
      //     'Rount Trip Scheduled': leg2.pickupDate,
      //     'Round Trip Airline Info': leg2.airline,
      //     'Round Trip Flight No': leg2.flightNo
      //   }
      //   if (leg1.isAsap) {
      //     segment['Date Scheduled'] = 'ASAP'
      //     segment['Round Trip Price'] = ''
      //     segment['Rount Trip Scheduled'] = ''
      //     segment['Rount Trip Airline Info'] = ''
      //     segment['Rount Trip Flight No'] = ''
      //   }
      //   window.opoliCNS('events', {
      //     key: 'ServicePage',
      //     segment: segment,
      //     url: null,
      //     widgetEvent: true
      //   })
      // }

      this.$root.$router.push('search')
      window.location.href = '#/search'
    },
    submit (event) {
      if (event) event.preventDefault()
      if (this.serviceLoading) { return }
      if (this.validate()) {
        this.$root.$emit('updateRsvp', {
          leg1: this.buildLegData('leg1'),
          leg2: this.buildLegData('leg2')
        })

        if (this._isAsap) {
          this.checkVenue()
          return
        }

        this.proceedToCustomer()
      }
    },
    proceedToCustomer () {
      this.$store.commit('reservation/setVenueData', {show: false})
      this.$root.$router.push('customer')
      window.location.href = '#/customer'
      if (/*CONFIG.Env == 'production' &&*/ window.gtag) { // eslint-disable-line
        gtag('event', `Service Continue`) // eslint-disable-line
      }
    },
    buildLegData (leg) {
      let rsvp = this.rsvpData
      if (leg === 'leg2' && !rsvp.isRoundtrip) return null

      let serviceData = ''
      let servicePricing = ''
      let airportFee = ''
      let serviceName = ''
      let priceType = this.lyft.enabled ? 'prices' : 'roundtrip'
      if (this.mtech.enabled) {
        serviceData = rsvp.mtech[leg].services[rsvp[leg].selectedService]
        servicePricing = serviceData.price.amount
        airportFee = 0
        serviceName = serviceData.desc
      } else {
        if (rsvp[leg].selectedService) {
          serviceData = rsvp[leg].services[rsvp[leg].selectedService]
          servicePricing = serviceData.prices[rsvp[leg].passenger - 1]
          if (rsvp.isRoundtrip && rsvp.leg1.selectedService === rsvp.leg2.selectedService) {
            servicePricing = serviceData[priceType][rsvp[leg].passenger - 1]
          }
          airportFee = serviceData.airportFee
          serviceName = serviceData.brandedName
        }
      }

      let pickupTitle = rsvp[leg].pickup.title
      if (rsvp[leg].apt !== '' && !rsvp[leg].isAirportPickup) {
        pickupTitle += ' Apt/Gate: ' + rsvp[leg].apt
      }

      let legData = {
        passengers: rsvp[leg].passenger,
        luggage: rsvp[leg].luggage,
        amount: servicePricing.price,
        originalPrice: servicePricing.original,
        flightName: rsvp[leg].airline || '',
        flightNumber: rsvp[leg].flightNo || '',
        airportFee: airportFee,
        serviceType: rsvp[leg].selectedService,
        distance: rsvp[leg].distance,
        etaInSec: rsvp[leg].eta,
        suggestedPrice: servicePricing.price,
        title: pickupTitle,
        address1: rsvp[leg].pickup.address1 || '',
        address2: rsvp[leg].pickup.address2 || '',
        city: rsvp[leg].pickup.city,
        state: rsvp[leg].pickup.state,
        zip: rsvp[leg].pickup.zip || '',
        pickUpLocation: rsvp[leg].pickup.lat + ',' + rsvp[leg].pickup.lng,
        pickupGeofenceId: rsvp[leg].pickup.geofenceId,
        pickupType: '',
        pickupFee: '0.00',
        pickupHasAirline: rsvp[leg].isAirportPickup,
        dropOffTitle: rsvp[leg].dropoff.title,
        dropOffAddress1: rsvp[leg].dropoff.address1 || '',
        dropOffAddress2: rsvp[leg].dropoff.address2 || '',
        dropOffCity: rsvp[leg].dropoff.city,
        dropOffState: rsvp[leg].dropoff.state,
        dropOffZip: rsvp[leg].dropoff.zip || '',
        dropOffLocation: rsvp[leg].dropoff.lat + ',' + rsvp[leg].dropoff.lng,
        dropoffGeofenceId: rsvp[leg].dropoff.geofenceId,
        type: 'U',
        dropOffType: 'U',
        offerFailureCount: 1,
        brandId: rsvp.brandId,
        pickupText: rsvp[leg].pickup.title,
        dropoffText: rsvp[leg].dropoff.title,
        serviceID: this.serviceId(rsvp[leg].selectedService),
        serviceName: serviceName,
        wheelchair: false,
        serviceDog: false
      }

      legData.pickupType = ''
      legData.pickupFee = '0.00'
      if (rsvp[leg].isAirportPickup) {
        legData.pickupTypes = {}
        legData.pickupType = 'Curbside'

        if (this.mtech.enabled) {
          legData.pickupTypes.Curbside = { label: 'Curbside', fee: 0 }
        } else {
          if (serviceData.curbside) {
            legData.pickupTypes.Curbside = { label: 'Curbside', fee: 0 }
          }
          if (serviceData.meetAndGreet) {
            legData.pickupTypes.MeetAndGreet = { label: 'Meet & Greet', fee: serviceData.pickupFee }
            if (!serviceData.curbside) {
              legData.pickupType = 'MeetAndGreet'
              legData.pickupFee = serviceData.pickupFee
            }
          }
        }
      }

      let timezone = rsvp[leg].timezone
      let threshold = 1.15
      if (rsvp[leg].isAsap) {
        let customerExpire = moment.utc().add(rsvp.driverResponseTime, 'seconds')

        legData.selectDate = 'ASAP'
        legData.expiredDate = customerExpire.format('YYYY-MM-DD HH:mm:ss')
        legData.selectDateLocal = moment.tz(moment().format('YYYY-MM-DD HH:mm:00'), timezone);
        legData.pickupDate = legData.selectDateLocal.format('lll');
        legData.pickupTimestamp = legData.selectDateLocal.format('X');
        legData.dropoffDate = legData.selectDateLocal.add(parseInt(rsvp[leg].eta * threshold), 'seconds').format('lll');
        legData.selectDateLocal = legData.selectDateLocal.format('YYYY-MM-DD HH:mm:00 ZZ');
      } else {
        let dispatchDateTime = moment(rsvp[leg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        legData.selectDate = dispatchDateTime.utc().format('YYYY-MM-DD HH:mm:ss')

        let dispatchExpire = moment(rsvp[leg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false)).utc().add(rsvp.driverResponseTime, 'seconds')
        legData.expiredDate = dispatchExpire.format('YYYY-MM-DD HH:mm:ss')

        let selectDateLocal = moment(rsvp[leg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        legData.selectDateLocal = moment.tz(selectDateLocal.format('YYYY-MM-DD HH:mm:00'), timezone);
        legData.pickupDate = legData.selectDateLocal.format('lll');
        legData.pickupTimestamp = legData.selectDateLocal.format('X');
        legData.dropoffDate = legData.selectDateLocal.add(parseInt(rsvp[leg].eta * threshold), 'seconds').format('lll');
        legData.selectDateLocal = legData.selectDateLocal.format('YYYY-MM-DD HH:mm:00 ZZ');
      }

      return legData
    },
    validate () {
      this.stepsError = { one: false, two: false, three: false, four: false }
      this.serviceLeg1Error = ''
      this.serviceLeg2Error = ''
      let leg1 = this.rsvpData.leg1
      let leg2 = this.rsvpData.leg2

      if (this.$refs.rideDetails1.validate()) {
        this.$refs.rideDetails1.validate()
      }
      if (this.rsvpData.isRoundtrip) {
        if (this.$refs.rideDetails2.validate()) {
          this.$refs.rideDetails2.validate()
        }
      }

      let hasError = false
      let errorMessages = []
      if (!this.charter.enabled) {
        if ((!leg1.isAsap && !leg1.pickupDate && !this.mtech.enabled) || leg1.passenger === '' || leg1.luggage === '' ||
          ((leg1.isAirportPickup || (CONFIG.featureToggle.requiredDropoffAirport && leg1.isAirportDropoff)) &&
          ((leg1.airline === '' || leg1.flightNo === '') && (!this._isAsap || this.lyft.enabled))) ||
          (this.mtech.enabled && !this.mtech.leg1.pickupDate)
        ) {
          hasError = true
          let elmnt = document.getElementById('rideDetails1')
          elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
          errorMessages.push(this.$t('serviceSelect.legErrorFields', {leg: 1}))
          this.stepsError.one = true
        }
      } else {
        if ((leg1.isAirportPickup && (leg1.airline === '' || leg1.flightNo === '')) ||
          !this.charter.startDate || !this.charter.endDate
        ) {
          hasError = true
          let elmnt = document.getElementById('rideDetails1')
          elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
          errorMessages.push(this.$t('serviceSelect.manualPickup', {leg: 1}))
          this.stepsError.one = true
        }
      }

      if (leg1.selectedService === '') {
        if (!hasError) {
          let elmnt = document.getElementById('service1')
          elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
        }

        hasError = true
        this.serviceLeg1Error = this.$t('serviceSelect.noSelectedService')
      }

      if (this.rsvpData.isRoundtrip && !this.charter.enabled) {
        if ((!leg2.isAsap && leg2.pickupDate === '') || leg2.passenger === '' || leg2.luggage === '' ||
          ((leg2.isAirportPickup || (CONFIG.featureToggle.requiredDropoffAirport && leg2.isAirportDropoff)) && (leg2.airline === '' || leg2.flightNo === ''))
        ) {
          if (!hasError) {
            let elmnt = document.getElementById('rideDetails2')
            elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
          }

          hasError = true
          errorMessages.push(this.$t('serviceSelect.manualPickup', {leg: 2}))
          this.stepsError.three = true
        }
        if (leg2.selectedService === '') {
          if (!hasError) {
            let elmnt = document.getElementById('service2')
            elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
          }

          hasError = true
          this.serviceLeg2Error = this.$t('serviceSelect.pleaseSelectService')
          errorMessages.push(this.$t('serviceSelect.legSelectService', {leg: 2}))
          this.stepsError.four = true
        }
      }

      if (this._serviceLeg1) {
        let addedTimeBuffer = this.mtech.enabled ? this.$store.state.reservation.webTimeBuffer : this.rsvpData.leg1.services[this._serviceLeg1].bufferTime
        let nowPlusBuffer = moment.tz(this.rsvpData.leg1.timezone).add(addedTimeBuffer, 'minutes')
        let pickupDate = moment.tz(this.rsvpData.leg1.pickupDate, 'MM/DD/YYYY hh:mmA', this.rsvpData.leg1.timezone)
        if (!leg1.isAsap && addedTimeBuffer && pickupDate.isBefore(nowPlusBuffer)) {
          hasError = true
          nowPlusBuffer = nowPlusBuffer.add(5, 'minutes').subtract(parseFloat(nowPlusBuffer.format('mm')) % 5, 'minutes')
          this.serviceLeg1Error = this.$t('serviceSelect.pickupTimeMustBe', {time: nowPlusBuffer.format('hh:mmA')})
          let elmnt = document.getElementById('service1')
          elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
        }
      }

      if (this.rsvpData.isRoundtrip && this._serviceLeg2) {
        let addedTimeBuffer2 = this.mtech.enabled ? this.$store.state.reservation.webTimeBuffer : this.rsvpData.leg2.services[this._serviceLeg2].bufferTime
        let nowPlusBuffer2 = moment.tz(this.rsvpData.leg2.timezone).add(this.rsvpData.leg2.services[this._serviceLeg2].bufferTime, 'minutes')
        let pickupDate2 = moment.tz(this.rsvpData.leg2.pickupDate, 'MM/DD/YYYY hh:mmA', this.rsvpData.leg2.timezone)
        if (addedTimeBuffer2 && pickupDate2.isBefore(nowPlusBuffer2)) {
          hasError = true
          nowPlusBuffer2 = nowPlusBuffer2.add(5, 'minutes').subtract(parseFloat(nowPlusBuffer2.format('mm')) % 5, 'minutes')
          this.serviceLeg2Error = this.$t('serviceSelect.pickupTimeMustBe', {time: nowPlusBuffer2.format('hh:mmA')})
          let elmnt = document.getElementById('service2')
          elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
        }
      }

      return !hasError
    },
    serviceId (service) {
      switch (service) {
        case 'shared': return 1
        case 'opoli': return 2
        case 'black': return 3
        case 'suv': return 4
        case 'shuttle': return 5
        case 'private': return 5
      }
    },
    _changeService (leg) {
      this.rsvpData[leg].selectedService = ''
      this.$store.commit('setCurrentIndex', 0)
      this.$store.commit('disablePreviousSteps', 3)
    },
    highlightCheck () {
      let leg1 = this.rsvpData.leg1
      let field = ''

      if (leg1.selectedService === '') { field = 'service' }
      if (leg1.luggage === '') { field = 'luggage' }
      // if (!leg1.isAirportPickup && leg1.apt === '') { field = 'apt' }
      if ((leg1.isAirportPickup || leg1.isAirportDropoff) &&
        (leg1.airline === '' || leg1.flightNo === '') && !leg1.isAsap) { field = 'airlineFlight' }
      if ((leg1.isAirportPickup || leg1.isAirportDropoff) && leg1.flightDate === '' && !leg1.isAsap) {
        field = 'pickupDate'
      } else if (leg1.pickupDate === '' && !leg1.isAsap && !leg1.isAirportPickup && !leg1.isAirportDropoff) {
        field = 'pickupDate'
      }

      this.$store.commit('reservation/setHighlight', {
        leg: 'leg1',
        value: field
      })

      let leg2 = this.rsvpData.leg2
      let field2 = ''

      if (leg2.selectedService === '') { field2 = 'service' }
      if (leg2.luggage === '') { field2 = 'luggage' }
      // if (!leg2.isAirportPickup && leg2.apt === '') { field2 = 'apt' }
      if ((leg2.isAirportPickup || leg2.isAirportDropoff) &&
        (leg2.airline === '' || leg2.flightNo === '')) { field2 = 'airlineFlight' }
      if ((leg2.isAirportPickup || leg2.isAirportDropoff) && leg2.flightDate === '' && !leg2.isAsap) {
        field2 = 'pickupDate'
      } else if (leg2.pickupDate === '' && !leg2.isAsap && !leg2.isAirportPickup && !leg2.isAirportDropoff) {
        field2 = 'pickupDate'
      }

      this.$store.commit('reservation/setHighlight', {
        leg: 'leg2',
        value: field2
      })
    },
    showAds () {
      document.body.className += 'widget-no-scroll ' + document.body.className
      this.$store.commit('ads/setShow', true)
    },
    closeAds () {
      document.body.classList.remove('widget-no-scroll')
      this.$store.commit('ads/setShow', false)
    },
    isUrl (val) {
      let regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/
      return regexp.test(val)
    },
    selectService (code) {
      this.closeAds()
      if (this.$refs.service1.selectService(code)) {
        this.$refs.service1.selectService(code)
      }
      if (this.isRoundtrip && this.$refs.service2.selectService(code)) {
        this.$refs.service2.selectService(code)
      }
    },
    getAds () {
      let self = this
      if (!self.$store.state.ads.check && self.$store.state.brandId) {
        self.$store.commit('ads/resetList')
        self.$store.commit('ads/setLoading', true)

        ApiAds.getAds(self, {brandId: self.$store.state.brandId}, (res) => {
          self.$store.commit('ads/setLoading', false)
          self.$store.commit('ads/setAdsCheck', true)
        })
      }
    },
    updatePickupType () {
      let user = this.$store.state.user
      let notInternational = true
      if (user.phone.number) {
        let userPhone = '+' + user.phone.code + user.phone.number
        notInternational = isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
      }
      ApiPickupType.update(this, {isUS: notInternational}, function () {})
    },
    checkSuggestedTime (leg) {
      let self = this
      let rsvp = self.rsvpData[leg]
      if (self.charter.enabled) { return }

      self.$store.commit('reservation/setSuggestedTimeShowLeg', {leg: leg, value: false})
      if (rsvp.airlineCode && rsvp.flightNo && /* rsvp.flightDate !== self.suggestedTime(leg) && */
        self.suggestedTime(leg) !== '' && ((rsvp.flightDate && !rsvp.isAsap) || rsvp.isAsap)
      ) {
        if (leg === 'leg2' && !rsvp.selectedService && self.rsvpData.leg1) {
          self.$store.commit('reservation/setSelectedService', {
            leg: 'leg2',
            value: self.rsvpData.leg1.selectedService
          })
          self.updatePickupType()
        }
        self.applySuggestedTime(leg)
        self.$store.commit('reservation/setSuggestedTimeShowLeg', {leg: leg, value: true})
        self.$store.commit('reservation/setSuggestedTimeShowModal', true)
      } else if (rsvp.airlineCode && rsvp.flightNo && rsvp.flightDate && !self.suggestedTime(leg)) {
        self.showSuggestedTimeError = true
        if (leg === 'leg2') {
          self.$store.commit('reservation/setSelectedService', { leg: 'leg2', value: '' })
          self.updatePickupType()
        }
      }
    },
    closeSuggestedTime () {
      this.$store.commit('reservation/setSuggestedTimeShowLeg', {leg: 'leg1', value: false})
      this.$store.commit('reservation/setSuggestedTimeShowLeg', {leg: 'leg2', value: false})
      this.$store.commit('reservation/setSuggestedTimeShowModal', false)
    },
    suggestedTime (leg) {
      let rsvp = this.rsvpData
      if (!rsvp.suggestedTime[leg].time) { return '' }

      if (this.mtech.enabled && rsvp[leg].selectedService) {
        let pickupTimes = this.mtech[leg].services[rsvp[leg].selectedService].pickupTimes
        if (pickupTimes.length) {
          return moment(pickupTimes[0].unix, 'X').format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        }
      }

      // let timezone = rsvp[leg].timezone
      let date = moment(rsvp.suggestedTime[leg].time, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      if (this.mtech.enabled) {
        date = moment(rsvp.suggestedTime[leg].time, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      }

      if (rsvp[leg].isAirportPickup) {
        let delay = rsvp.suggestedTime[leg].isDomestic ? 'ArrivalDomesticDelay' : 'ArrivalInternationalDelay'
        date.add(this.$settings.get(delay), 'minutes')
      } else if (rsvp[leg].isAirportDropoff) {
        let delay = rsvp.suggestedTime[leg].isDomestic ? 'DepartureDomesticBuffer' : 'DepartureInternationalBuffer'
        let eta = Math.ceil(rsvp[leg].eta / 60)
        let btt = Math.ceil(eta * 1.15)
        let selectedService = rsvp[leg].selectedService
        if (selectedService && rsvp[leg].services[selectedService] && rsvp[leg].services[selectedService].isShared) {
          btt = Math.ceil(eta * (1 + (this.$settings.get('OfferLimitThreshold') / 100)))
          btt = (btt - (btt % 5)) + 5
        }
        let timeDelay = Math.ceil(parseFloat(this.$settings.get(delay)))
        date.subtract(timeDelay + btt, 'minutes')
        date.subtract(parseInt(date.format('mm')) % 5, 'minutes')
      }

      if (this.offsets['a' + date.format('e')] && rsvp[leg].isAirportDropoff) {
        let found = false
        this.offsets['a' + date.format('e')].forEach(function (data, index) {
          let time = moment(date.format('HHmm'), 'HHmm')
          let start = moment(data.start, 'HHmm')
          let end = moment(data.end, 'HHmm')
          if (time.isBetween(start, end) && !found) {
            found = true
            if (data.value.indexOf('-') > -1) {
              date.subtract(data.value.substring(1, data.value.length), 'minutes')
            } else {
              date.add(data.value, 'minutes')
            }
          }
        })
      }

      // let timenowTz = moment().tz(timezone)
      // return !date.isBefore(timenowTz.add(this.$settings.get('WebTimeBuffer'), 'minutes')) ? date.format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false)) : ''
      return date.format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
    },
    applySuggestedTime (leg) {
      if (
        this.mtech.enabled && this._serviceLeg1 &&
        this.mtech[leg].services[this._serviceLeg1].pickupTimes &&
        this.mtech[leg].services[this._serviceLeg1].pickupTimes.length
      ) {
        this.$store.commit('reservation/setMtechLegData', {
          leg: leg,
          fields: {
            pickupDate: moment(this.mtech[leg].services[this._serviceLeg1].pickupTimes[0].unix, 'X').tz(this.rsvpData[leg].timezone).format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
          }
        })
      } else if (!this.rsvpData.customPickupTime[leg]) {
        this.$store.commit('reservation/setPickupDate', {
          leg: leg,
          value: this.suggestedTime(leg)
        })
      }

      this.$store.commit('reservation/setSuggestedTimeShowLeg', {leg: leg, value: false})
      if (leg === 'leg1' && this.showSuggestedTimeLeg2) { return }
      this.closeSuggestedTime()
    },
    showNextSuggestion () { this.$store.commit('reservation/setSuggestedTimeShowLeg', {leg: 'leg1', value: false}) },
    setPickupTimeOffsets () {
      let self = this
      let PickupTimeOffsets = this.$settings.get('PickupTimeOffsets')
      if (PickupTimeOffsets) {
        let split = PickupTimeOffsets.split(',')
        split.forEach(function (val, index) {
          if (!self.offsets['a' + val.substring(0, 1)]) {
            self.offsets['a' + val.substring(0, 1)] = []
          }
          self.offsets['a' + val.substring(0, 1)].push({
            start: val.substring(1, 5),
            end: val.substring(5, 9),
            value: val.substring(9, val.length)
          })
        })
      }
    },
    showLaxIntructionImg (type) {
      if (window.innerWidth > 640) {
        this.LAXInstructionImg.show = true
        this.LAXInstructionImg.type = type
      }
    },
    initRerender (target) {
      this.rerender[target] = false
      setTimeout(() => {
        this.rerender[target] = true
      }, 200)
    },
    checkVenue () {
      let self = this
      let pickup = this.rsvpData.leg1.pickup
      let chk = this.rsvpData.venue.list.find(x => x.lat === pickup.lat && x.lng === pickup.lng)
      if (chk) {
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('reservation/setVenueData', {show: true})
        return
      }

      let request = {
        lat: pickup.lat,
        lng: pickup.lng,
        type: 'pickup',
        radius: 0.01
      }
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.get(self, '/venues', request, res => {
        if (res.error ||
          (res.venues && !res.venues.length) ||
          (res.venues && res.venues.length && !res.venues[0].zones.length)
        ) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.proceedToCustomer()
          return
        }

        if (res.venues[0].category === 'airport') {
          self.$sdk.get(self, '/geofences', {lat: pickup.lat, lng: pickup.lng}, res2 => {
            if (res2.error || (!res2.error && res2.list && res2.list[0] && res2.list[0].type !== 'airport')) {
              self.$store.commit('global/setLoaderData', {show: false})
              self.proceedToCustomer()
              return
            }
            self.processVenueData(res, request)
          }, '1.1')
          return
        }

        self.processVenueData(res, request)
      }, '2.0')
    },
    processVenueData (res, request) {
      let self = this
      let tmpData = {
        name: res.venues[0].name,
        lat: request.lat,
        lng: request.lng,
        zones: []
      }
      res.venues[0].zones.forEach(x => {
        let tmpLocs = []
        x.locations.forEach(y => {
          tmpLocs.push({
            lat: y.lat,
            lng: y.lng,
            name: y.name,
            directions: self.lyftSanitize(y.walking_directions),
            disabled: y.disabled_ride_types
          })
        })
        tmpData.zones.push({
          name: x.name,
          directions: self.lyftSanitize(x.walking_directions),
          locations: tmpLocs
        })
      })
      self.$store.commit('reservation/addVenueList', tmpData)
      self.$store.commit('global/setLoaderData', {show: false})
      self.$store.commit('reservation/setVenueData', {show: true})
    },
    lyftSanitize (x) {
      return x.replaceAll('Lyft', '').replaceAll('lyft', '').replaceAll('  ', ' ')
    }
  },
  watch: {
    _isAsap: function (value) {
      if (value) { this.$store.commit('reservation/setIsRoundtrip', false) }
    },
    _serviceLeg1: function (value) {
      this.$forceUpdate()
      this.$root.$emit('updateRsvp', {
        leg1: this.buildLegData('leg1'),
        leg2: this.buildLegData('leg2')
      })
      if (value) {
        let isShared = value === 'shared'
        if (this.lastSelectedService.leg1 !== isShared && !this.rsvpData.leg1.isAsap) {
          this.lastSelectedService.leg1 = isShared
          // this.checkSuggestedTime('leg1')
        }

        if (this.serviceLeg1Error) this.serviceLeg1Error = ''

        clearTimeout(this.scrollDelay)
        this.scrollDelay = setTimeout(function () {
          let elmnt = document.getElementById('service1')
          elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
        }, 200)
      }
    },
    _serviceLeg2: function (value) {
      this.$root.$emit('updateRsvp', {
        leg1: this.buildLegData('leg1'),
        leg2: this.buildLegData('leg2')
      })
      if (value) {
        let isShared = value === 'shared'
        if (this.lastSelectedService.leg2 !== isShared) {
          this.lastSelectedService.leg2 = isShared
          // this.checkSuggestedTime('leg2')
        }

        if (this.serviceLeg2Error) this.serviceLeg2Error = ''

        clearTimeout(this.scrollDelay)
        this.scrollDelay = setTimeout(function () {
          let elmnt = document.getElementById('service2')
          elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
        }, 400)
      }
    },
    _brandId: function (value) {
      if (value) {
        this.getAds()
      }
    },
    // _airlineLeg1: function (value) { this.checkSuggestedTime('leg1') },
    // _airlineLeg2: function (value) { this.checkSuggestedTime('leg2') },
    // _flightNoLeg1: function (value) { this.checkSuggestedTime('leg1') },
    // _flightNoLeg2: function (value) { this.checkSuggestedTime('leg2') },
    _suggestedTimeLeg1: function (value) {
      // this.checkSuggestedTime('leg1')
      this.applySuggestedTime('leg1')
    },
    _suggestedTimeLeg2: function (value) {
      // this.checkSuggestedTime('leg2')
      this.applySuggestedTime('leg2')
    },
    showSuggestedTimeLeg1: function (value) { this.applySuggestedTime('leg1') },
    showSuggestedTimeLeg2: function (value) { this.applySuggestedTime('leg2') },
    _pickupTimeOffsets: function (value) { if (value) this.setPickupTimeOffsets() },
    _applySuggestedLeg2 (val) {
      if (val) {
        this.$store.commit('reservation/setApplySuggestedLeg2', false)
        this.applySuggestedTime('leg2')
      }
    }
  },
  mounted () {
    this.highlightCheck()
    this.setPickupTimeOffsets()

    this.$store.commit('setCurrentIndex', 0)

    if (this.isRoundtrip && this.rsvpData.getRtPricing) {
      this.$store.commit('reservation/setRtPricing', false)
      this.setRoundtrip(1)
    } else this.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})

    if (!this.rsvpData.leg1.pickup.title && !this.charter.enabled ||
      (this.charter.enabled && !this.charter.pickup.title)
    ) {
      this.back()
    }

    this.getAds()
  }
}
</script>

<style lang="scss" scoped>
.clearfix{ clear: both; }
.ads{
  display: flex;
  margin: 0 auto 20px;
  max-width: 500px;
  cursor: pointer;
  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.2);

  .img{
    width: 100px;
    flex: 0 0 100px;
    padding: 10px;
    background: #fff;
  }
  .text{
    width: 100%;
    background: #FFF;
    padding: 10px 15px;
    text-align: center;

    span{ display: block; }
    .title{
      font-size: 17px;
      font-weight: 600;
    }
    .desc{
      font-size: 13px;
      color: #555;
    }
  }
}

.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}
.ads-modal{
  background-color: #fff;
  max-width: 500px;
  margin: 10px auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;

  .ads-title{
    padding: 15px;
    color: #333;
    background: #FFF;
    font-weight: 600;
    text-align: center;
    i{
      float: right;
      color: #fb5050;
      cursor: pointer;
    }
  }
  .ads-img img { width: 100%; }
  .ads-heading{
    font-weight: 600;
    padding: 10px 15px;
  }
  .ads-desc{
    margin: 0 0 5px;
    padding: 0 15px 10px;
    font-size: 15px;
    line-height: 150%;
  }
  .ads-cta{
    text-align: center;
    margin-bottom: 20px;
  }
}

h3{
  font-size: 1.5em!important;
  &.has-error{ color: #EB5837; }
}

.card{ position:relative; }
.change-service{
  position: absolute;
  top: 25px;
  right: 20px;
}
.roundtrip-controls {
  text-align: center;
  padding: 20px 0 0;
  font-size: 18px;
  line-height: 18px;

  & > label {
    display: inline-block;
    vertical-align: middle;
  }

  & .radio-input {
    & > * {
      display: inline-block;
      vertical-align: middle;
    }

    & input {
      height: 19px;
      margin:0 3px 0 10px;
    }
  }
}

.roundtrip-discount{
  position: relative;
  display: inline-block;

  img{
    width: 330px;
    position: relative;
    z-index: 1;
  }
  span{
    color: #fff;
    position: absolute;
    left: 63px;
    top: 43px;
    width: 86px;
    display: inline-block;
    font-size: 24px;
    font-weight: 600;
    transform: translateX(-50%);
    z-index: 2;

    &.seven{
      font-size: 21px;
    }
    &.eight, &.nine{
      font-size: 18px;
    }
    &.ten-above {
      font-size: 13px;
    }
  }
}

.continue-btn, .back-btn{
  text-decoration: none!important;
}

.service-na{
  margin: 15px 0;

  b{
    color: #fff!important;
    font-weight: 700;
  }
}

.back-btn, .continue-btn{ width: 142px; }
a.back-btn{
  float: left;

  span{
    color: #333!important;
  }
}
.continue-btn{ float: right; }
.return-trip-btn{
  color: #fff;
  background: #32a9ef;
  border-color: #208ccc;
  position: relative;

  &:hover{ background: #278fcc; }
  .float-effect{
    width: 100%;
    position: absolute;
    bottom: 100%;
    left: 0;
    animation: float 1s linear infinite forwards;
    z-index: 5;
  }
  .bubble{
    color: #fff;
    padding: 4px 10px;
    font-size: 14px;
    border-radius: 4px;
    background: #3c3c3c;
    bottom: calc(100% + 13px);
    left: 50%;
    width: 140px;
    position: absolute;
    transform: translateX(-50%);

    &::before{
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid #3c3c3c;
    }
  }
}

.service-controls {
  text-align: center;
  padding: 10px 0 30px 0;

  & .op-btn {
    & > * {
      display: inline-block;
      vertical-align: middle;
    }
  }
}

.roundtrip-box{
  position: relative;
  .cancel-roundtrip{
    position: absolute;
    top: 25px;
    right: 20px;
    text-decoration: underline;
  }
}

.service-intro{
  text-align: center;
  padding: 10px;
  margin: 5px 0;
}

.error-msg{
  text-align: center;
  background: #eb5837;
  display: block;
  margin-bottom: 5px;
  padding: 3px;
  color: #fff;
  font-size: 14px;
  font-style: italic;
}

.suggested-time-box{
  max-width: 450px;
  width: 100%;
  margin: 10px auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
  text-align: center;
  position: relative;

  .box{
    width: 100%;
    padding: 15px;
    background-color: #fff;
    border-radius: 3px;

    &.active{
      top: 0;
    }
  }
  .title{
    font-size: 21px;
    font-weight: 600;
  }
  p{ margin-bottom: 10px; }
  .time{
    font-size: 21px;
    font-weight: 600;
    word-spacing: 5px;
    color: #3ac568;
    display: inline-block;
    margin-bottom: 20px;
    border-bottom: 1px solid #7cf5a4;
  }
  .keep{
    color: #999!important;
    margin: 15px 0 5px;
    display: block;
    text-decoration: underline;
  }
}

.suggested-time-error-box{
  max-width: 450px;
  width: 100%;
  margin: 10px auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
  text-align: center;
  position: relative;
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  font-size: 18px;

  i{
    display: block;
    margin-bottom: 10px;
  }
  span{
    display: block;
    margin-bottom: 30px;
  }
}

.lax-instruction{
  h3{ width: 100%; }
  .medium-8{ padding-right: 10px; }
  .steps{
    font-size: 14px;
    margin-bottom: 5px;
    b{ margin-right: 5px; }
  }
  .thumbnail{ cursor: pointer; }
  .large-view{
    font-size:13px;
    display: block;
    text-align: center;
  }
}
.LAX-instruction-img{
  max-width: 900px;
  width: 100%;
  margin: 10px auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
  text-align: center;
  position: relative;
  background: #fff;
  border-radius: 4px;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .30s ease backwards; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}
.slide-up-enter-active, .slide-up-leave-active { transition: all .35s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

@keyframes float {
  0%, 100%{ transform: translateY(0); }
  40%, 60%{ transform: translateY(3px); }
  80%, 90%{ transform: translateY(-2px); }
}

.return-trip-btn.small{ display: none; }
@media only screen and (max-width: 40em) {
  .return-trip-btn{ display: none; }
  .return-trip-btn.small{
    display: block;
    margin-bottom: 10px;
  }
  .back-btn, .continue-btn{ width: calc(50% - 5px); }
  .lax-instruction{
    .medium-8{ padding-right: 0; }
    .thumbnail{ margin-top: 10px; }
    .large-view{ display: none; }
  }
}
@media only screen and (max-width: 460px) {
  .change-service{
    right: 0;
    left: 20px;
    top: 55px;
  }
  #service1 h3.margin-t-z{ margin-bottom: 0px; }
  .error-msg{
    margin-top:35px;
  }
}
@media only screen and (max-width: 530px) {
  .cancel-roundtrip{
    right: 0;
    left: 20px;
    top: 55px!important;
  }
  #rideDetails2 h3.margin-t-z{ margin-bottom: 35px; }
}
</style>



// WEBPACK FOOTER //
// index.vue?7873ac16